interface TimelineStageProps {
	stepNumber: number;
	stepLabel: string;
	isLast: boolean;
	children: React.ReactNode;
}

export const TimelineStage = ({
	stepNumber,
	stepLabel,
	isLast,
	children,
}: TimelineStageProps) => (
	<div style={{ display: 'flex', gap: 12 }}>
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				width: 24,
				flexShrink: 0,
			}}
		>
			<div
				style={{
					width: 22,
					height: 22,
					borderRadius: '50%',
					background: '#1473E6',
					color: 'white',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					fontSize: '0.625rem',
					fontWeight: 700,
					flexShrink: 0,
					letterSpacing: 0,
				}}
			>
				{stepNumber}
			</div>
			{!isLast && (
				<div
					style={{
						width: 1,
						flex: 1,
						background: '#E0E0E0',
						minHeight: 16,
						marginTop: 3,
					}}
				/>
			)}
		</div>

		<div
			style={{
				flex: 1,
				minWidth: 0,
				paddingBottom: isLast ? 0 : 28,
			}}
		>
			<div
				style={{
					height: 22,
					display: 'flex',
					alignItems: 'center',
					marginBottom: 8,
				}}
			>
				<span
					style={{
						fontSize: '0.8125rem',
						fontWeight: 600,
						color: 'var(--text-primary)',
					}}
				>
					{stepLabel}
				</span>
			</div>

			{children}
		</div>
	</div>
);
